import { makeStyles } from "@material-ui/core/styles";
import React, { cloneElement } from "react";

const useListActionToolbarStyles = makeStyles({
    toolbar: {
        textAlign: "right",
        marginTop: -1,
        marginBottom: -1,
    },
});

export const ListActionToolbar = ({ children, ...props } : {children: JSX.Element[]}) => {
    const classes = useListActionToolbarStyles();
    return (
        <div className={classes.toolbar}>
            {children.map((child, index) => cloneElement(child, {key: index, ...props}))}
        </div>
    );
};